const e = "styles-module__emailInput___dj4ro", o = "styles-module__error___ogXmH", r = {
  emailInput: e,
  error: o
};
export {
  r as default,
  e as emailInput,
  o as error
};
